import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import './CourseDetails.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../api';
import { getProfilePictureUrl } from '../../utils/apiHelper';
import { format } from 'date-fns'; // ✅ Import date-fns for formatting dates
import {
  FaShoppingCart,
  FaCreditCard,
  FaPlay,
  FaTimes,
  FaCheck,
  FaClock,
  FaFileDownload,
  FaClipboardList,
  FaMobileAlt,
  FaCertificate,
  FaListAlt,
  FaStar,
  FaHeart,
  FaShareAlt,
  FaChevronDown,
  FaChevronRight,
  FaArrowLeft,
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import UsersTopbar from '../UsersTopbar/UsersTopbar';
import defaultProfilePic from '../../assets/defaultProfilePic.png';
import useBlockCheck from '../../hooks/useBlockCheck'; // Import the hook
import { Modal, Button, Input } from 'antd';
import { getDisplayPrices } from '../../utils/priceUtils';

const CourseDetails = () => {
  useBlockCheck('user'); // 🔥 Prevents blocked users from accessing this page
  const { profile, profileLoading } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('openGift') === 'true') {
      setIsGiftModalOpen(true);
    }
  }, [location]);

  const { token } = useAuth();
  const { addToCart, isInCart } = useCart();
  const [course, setCourse] = useState(null);
  const [_error, _setError] = useState('');
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [_profilePicture, setProfilePicture] = useState();
  const totalHours = Math.floor(course?.totalHours || 0); // Get whole hours
  const totalMinutes = Math.round((course?.totalHours || 0) * 60) % 60; // Convert remaining part to minutes
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [_loading, setLoading] = useState(false);
  const [_totalInstructorCourses, setTotalInstructorCourses] = useState(0);
  const [_userName, setUserName] = useState('Learner');
  const [_buyNow, setBuyNow] = useState([]); // ✅ Track Buy Now items
  const [expandedSections, setExpandedSections] = useState({});
  const [instructorCourses, setInstructorCourses] = useState([]); // Add this state to track the instructor's other courses
  const [wishlist, setWishlist] = useState([]); // Track wishlist items
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false); const [showShareOptions, setShowShareOptions] = useState(false); // State to manage share options visibility
  const [isGiftModalOpen, setIsGiftModalOpen] = useState(false);
  const [giftMessage, setGiftMessage] = useState('');
  const [giftEmail, setGiftEmail] = useState('');
  const [giftEmailError, setGiftEmailError] = useState('');
  const [isGiftChecking, setIsGiftChecking] = useState(false);
  const [purchasedCourses, setPurchasedCourses] = useState([]);
  const isPurchased = purchasedCourses.some((item) => item._id === id);
  const [instructor, setInstructor] = useState({}); // Add at top
  const [instructorDetails, setInstructorDetails] = useState(null);

  useEffect(() => {
    const fetchInstructorInfo = async () => {
      try {
        if (!course?.userId) return;

        const res = await axios.get(api.getInstructorDetailsWithCourses(course.userId), {
          headers: { Authorization: `Bearer ${token}` },
        });
        setInstructor(res.data.instructor || {});


        setInstructor(res.data.instructor || {});
      } catch (err) {
        console.error('Error fetching instructor details:', err);
      }
    };

    fetchInstructorInfo();
  }, [course?.userId, token]);



  // Set offer expiry time (2 days from now)
  const offerEndTime = new Date();
  offerEndTime.setDate(offerEndTime.getDate() + 2); // 2 days from now
  offerEndTime.setHours(23, 59, 59, 999); // End at 11:59:59 PM

  const [timeLeft, setTimeLeft] = useState(
    Math.floor((offerEndTime - new Date()) / 1000),
  );

  const calculateTotalLessons = (sections) => {
    return sections.reduce((total, section) => total + (section.lessons?.length || 0), 0);
  };

  const toggleSection = (index) => {
    setExpandedSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleDescription = () => {
    setIsDescriptionExpanded((prev) => !prev);
  };

  const getFormattedDuration = (durationInSeconds) => {
    const totalMinutes = Math.floor(durationInSeconds / 60); // Convert seconds to minutes
    const hours = Math.floor(totalMinutes / 60); // Extract whole hours
    const minutes = totalMinutes % 60; // Get remaining minutes

    return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
  };

  useEffect(() => {
    if (!profileLoading && profile) {
      setProfilePicture(
        getProfilePictureUrl(profile.profilePicture, api.img, defaultProfilePic, profile.name),
      );
    }
  }, [profile, profileLoading]);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(api.getCourseById(id), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // console.log('API Response:', response.data); // Debug the API response
        // console.log('Course details:', response.data.course); // Debugging
        setCourse(response.data.course);
        setTotalInstructorCourses(response.data.totalInstructorCourses);

        // Calculate total number of documents
        const documentCount = response.data.course.sections.reduce(
          (totalDocs, section) => {
            return (
              totalDocs +
              section.lessons.reduce((lessonDocs, lesson) => {
                return (
                  lessonDocs + (lesson.documents ? lesson.documents.length : 0)
                );
              }, 0)
            );
          },
          0,
        );

        setTotalDocuments(documentCount);
      } catch (error) {
        console.error('Error fetching course details:', error);
        toast.error('Failed to load course details');
      } finally {
        setLoading(false);
      }
    };

    fetchCourseDetails();
  }, [id, token]);

  useEffect(() => {
    const fetchInstructorCourses = async () => {
      try {
        const response = await axios.get(api.getInstructorCourses(course.userId), {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Exclude the current course from the list
        const otherCourses = response.data.courses.filter((c) => c._id !== course._id);
        setInstructorCourses(otherCourses);
      } catch (error) {
        console.error('Error fetching instructor courses:', error);
      }
    };

    if (course?.userId) {
      fetchInstructorCourses();
    }
  }, [course, token]);
  useEffect(() => {
    const fetchPurchasedCourses = async () => {
      try {
        const res = await axios.get(api.getPurchasedCourses, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPurchasedCourses(res.data.courses || []);
      } catch (error) {
        console.error('Error fetching purchased courses:', error);
      }
    };

    if (token) {
      fetchPurchasedCourses();
    }
  }, [token]);

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const response = await axios.get(api.getCartAndWishlist, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWishlist(response.data.wishlist || []);
      } catch (error) {
        console.error('Error fetching wishlist:', error);
      }
    };

    fetchWishlist();
  }, [token]);

  useEffect(() => {
    if (timeLeft <= 0) return; // Stop when time reaches zero

    const interval = setInterval(() => {
      setTimeLeft(Math.floor((offerEndTime - new Date()) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  // Format time into DD:HH:MM:SS
  // const formatTime = (seconds) => {
  //   const days = Math.floor(seconds / (3600 * 24));
  //   const hours = Math.floor((seconds % (3600 * 24)) / 3600);
  //   const minutes = Math.floor((seconds % 3600) / 60);
  //   const secs = seconds % 60;
  //   return `${days}d ${hours}h ${minutes}m ${secs}s`;
  // };

  const handleAddToCart = async () => {
    try {
      await addToCart(id);
      toast.success('Course added to cart successfully!');
    } catch (error) {
      console.error('Error adding to cart:', error);
      toast.error('Failed to add course to cart');
    }
  };

  const handleBuyNow = async (courseId, price) => {
    try {
      await axios.post(
        `${api.addToBuyNow}`,
        { courseId },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // ✅ Update local Buy Now state
      setBuyNow([{ _id: courseId, status: 3 }]); // Ensure only one course is in Buy Now

      navigate(`/checkout?courseIds=${courseId}`);
    } catch (error) {
      console.error('Error adding to Buy Now:', error);
    }
  };

  useEffect(() => {
    const fetchInstructorRatings = async () => {
      if (!course || !course.userId) {
        return;
      }

      try {
        const response = await axios.get(
          api.getInstructorRatings(course.userId),
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        // console.log('Instructor Ratings API Response:', response.data);
        setInstructorDetails(response.data.instructor);
      } catch (error) {
        console.error('Error fetching instructor ratings:', error);
      }
    };

    fetchInstructorRatings();
  }, [course, token]);

  const handleWishlistToggle = async (courseId) => {
    try {
      if (wishlist.some((item) => item._id === courseId)) {
        await axios.delete(`${api.addToWishlist}/${courseId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setWishlist((prev) => prev.filter((item) => item._id !== courseId));
      } else {
        await axios.post(
          `${api.addToWishlist}`,
          { courseId },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setWishlist([...wishlist, { _id: courseId, status: 1 }]); // Status 1 for wishlist
      }
    } catch (error) {
      console.error('Error toggling wishlist:', error);
    }
  };

  const courseInCart = isInCart(id);
  const isInWishlist = wishlist.some((item) => item._id === id);

  useEffect(() => {
    if (!profileLoading && profile) {
      const name = profile.name || 'Learner';
      setUserName(name);
      setProfilePicture(
        getProfilePictureUrl(profile.profilePicture, api.img, defaultProfilePic, name),
      );
    }
  }, [profile, profileLoading]);

  const handleLessonClick = (lesson) => {
    if (lesson.video) {
      setSelectedLesson(lesson);
      setIsVideoModalOpen(true);
    }
  };

  // if (error) {
  //   return <p className="cd-error">{error}</p>;
  // }

  if (!course) {
    return <p className="cd-loading">Loading course details....</p>;
  }

  // Get display prices with default fallback
  const { actualPrice, offerPrice } = getDisplayPrices(course);
  // Determine if course is truly free based on database values first, not calculated display prices
  // A course is free if: isFree flag is set, OR offerPrice is explicitly 0, OR both prices are 0/undefined
  const isFree = course.isFree || 
                 course.offerPrice === 0 ||
                 (course.actualPrice === 0 && course.offerPrice === undefined);

  const totalLessons = calculateTotalLessons(course?.sections || []);
  const handleGiftCourse = async () => {
    setGiftEmailError('');
    if (!giftEmail || !giftEmail.includes('@')) {
      setGiftEmailError('Please enter a valid email address.');
      return;
    }

    // Check if user is trying to gift to themselves
    if (giftEmail.toLowerCase() === profile?.email?.toLowerCase()) {
      toast.error('You cannot gift a course to yourself!');
      setIsGiftModalOpen(false);
      return;
    }

    setIsGiftChecking(true);

    try {
      // Check if recipient exists
      const res = await axios.post(api.checkEmailExists, { email: giftEmail });

      const emailExists = res.data.exists;
      const recipientCourses = res.data.purchasedCourses || [];

      // Check if recipient already owns the course
      const alreadyHasCourse = recipientCourses.some(c => c.toString() === course._id.toString());

      if (alreadyHasCourse) {
        setIsGiftModalOpen(false);
        toast.warning('This course is already purchased by the recipient. You can gift another course to them.');
        return;
      }

      if (emailExists) {
        // Redirect to checkout
        const params = new URLSearchParams({
          courseIds: course._id,
          giftEmail,
          giftMessage: giftMessage.trim() || '',
        });
        navigate(`/checkout?${params.toString()}`);
      } else {
        // Send gift email
        await axios.post(api.sendGiftEmail, {
          email: giftEmail,
          sender: profile?.email,
          courseId: course._id,
          courseTitle: course.title,
          giftMessage: giftMessage.trim(),
          senderName: profile?.name || 'A friend',
        });
        setIsGiftModalOpen(false);
        toast.success('We have sent them an email to join UlsaApp.');
      }

    } catch (err) {
      console.error(err);
      setGiftEmailError('Error checking email or sending gift. Try again.');
    } finally {
      setIsGiftChecking(false);
    }
  };

  const handleGiftKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGiftCourse();
    }
  };

  return (
    <div>
      <UsersTopbar />
      <div className="cd-course-details-container">
        <div className="cd-course-left">
          <button
            onClick={() => navigate(-1)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              marginBottom: '16px',
              backgroundColor: 'transparent',
              border: '1px solid #ddd',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              color: '#333',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#f5f5f5';
              e.currentTarget.style.borderColor = '#999';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = '#ddd';
            }}
          >
            <FaArrowLeft /> Back
          </button>
          <p>
            <Link
              to={`/category/${course?.category?.name}/${course?.subcategory?.name}`}
              className="cd-category-link"
            >
              {course?.category?.name} | {course?.subcategory?.name}
            </Link>
          </p>
          <h1 className="cd-course-title">{course.title}</h1>
          <p className="cd-course-description">{course.description}</p>
          <p className="cd-course-rating">
            ⭐ {course.averageRating || '0.0'} ({course.totalRatings || 0}{' '}
            ratings) |{' '}
            {Array.isArray(course.enrolledStudents)
              ? course.enrolledStudents.length
              : 0}{' '}
            Students
          </p>
          <p className="cd-course-language">
            Language: {course?.language || 'Not specified'}
          </p>

          {/* What you'll learn */}
          <h2 className="center">
            <FaCheck /> What you&apos;ll learn
          </h2>
          <ul className="cd-course-learnings">
            {(course.youLearner || []).map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>

          {/* Course includes */}
          <h3>
            <FaListAlt /> This course includes:
          </h3>

          <ul className="cd-course-includes">
            <li>
              <FaClock />{' '}
              <strong>
                {totalHours}.{totalMinutes} hours on-demand video
              </strong>
            </li>
            <li>
              <FaClipboardList />
              <strong>Total {course?.sections?.length || 0} Sections</strong>
            </li>
            <li>
              <FaClipboardList />
              <strong>Total {totalLessons} Lessons</strong>
            </li>
            <li>
              <FaFileDownload />{' '}
              <strong>{totalDocuments} downloadable resources</strong>
            </li>
            <li>
              <FaMobileAlt /> <strong> Access on Mobile</strong>
            </li>
            <li>
              <FaCertificate /> <strong>Certificate of completion</strong>
            </li>
          </ul>
          {/* Course Content */}
          <h3>
            {' '}
            <FaListAlt /> Course Content
          </h3>
          <div className="cd-course-summary">
            <p>{course?.sections?.length || 0} Sections</p>
            <p>{totalLessons} Lessons</p>
            <p>
              {totalHours}h {totalMinutes}m total length
            </p>
          </div>

          <div className="cd-course-content">
            {course.sections && course.sections.length > 0 ? (
              course.sections.map((section, sectionIndex) => {
                const totalDuration = section.lessons.reduce(
                  (acc, lesson) => acc + (lesson.duration || 0),
                  0,
                );

                return (
                  <div
                    key={sectionIndex}
                    className={`cd-section ${expandedSections[sectionIndex] ? 'expanded' : ''
                    }`}
                  >
                    <div
                      className="cd-section-header"
                      onClick={() => toggleSection(sectionIndex)}
                    >
                      <div className="cd-section-title-container">
                        <h3 className="cd-section-title">
                          <span>
                            {expandedSections[sectionIndex] ? '▾' : '▸'} Section{' '}
                            {sectionIndex + 1} - {section.name}
                          </span>
                        </h3>
                        <div className="cd-section-meta">
                          {section.lessons.length} lectures •{' '}
                          {getFormattedDuration(totalDuration)}
                        </div>
                      </div>
                      <button className="cd-toggle-button">
                        {expandedSections[sectionIndex] ? (
                          <FaChevronDown />
                        ) : (
                          <FaChevronRight />
                        )}
                      </button>
                    </div>

                    {expandedSections[sectionIndex] && (
                      <div className="cd-lessons">
                        {section.lessons.map((lesson, lessonIndex) => (
                          <div key={lessonIndex} className="cd-lesson">
                            <p>
                              <strong>Lesson {lessonIndex + 1}:</strong>{' '}
                              <span
                                className="cd-lesson-title"
                                onClick={() => lesson.preview ? handleLessonClick(lesson) : null}
                                style={{
                                  cursor: lesson.preview && lesson.video ? 'pointer' : 'default',
                                }}
                              >
                                {lesson.name}
                                {lesson.preview && (
                                  <span className="cd-preview-tag">Preview</span>
                                )}
                              </span>

                              {lesson.questions && (
                                <span className="cd-tag">
                                  {lesson.questions} question
                                  {lesson.questions > 1 ? 's' : ''}
                                </span>
                              )}
                            </p>
                            <span className="cd-duration">
                              {getFormattedDuration(lesson.duration)}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <p>No course content available.</p>
            )}
          </div>

          {/* Course Requirements */}
          {course.requirements && course.requirements.length > 0 && (
            <div className="cd-course-requirements">
              <h3>Requirements</h3>
              <ul>
                {course.requirements.map((req, index) => (
                  <li key={index}>{req}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Who is this course for? */}
          {course.targetAudience && course.targetAudience.length > 0 && (
            <div className="cd-course-target-audience">
              <h3>To Whom this course for?</h3>
              <ul>
                {course.targetAudience.map((aud, idx) => (
                  <li key={idx}>{aud}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Detailed Description */}
          {course.detailedDescription && (
            <div className="cd-detailed-description">
              <h3>Description</h3>
              <p>
                {isDescriptionExpanded
                  ? course.detailedDescription
                  : `${course.detailedDescription.slice(0, 300)}...`}
              </p>
              <button className="cd-show-more-btn" onClick={toggleDescription}>
                {isDescriptionExpanded ? 'Show Less' : 'Show More'}
              </button>
            </div>
          )}

          {/* Author Section */}
          <div className="cd-info-card">
            <h2 className="center">
              <strong>Instructor </strong>
            </h2>

            <div
              className="cd-instructor-info"
              onClick={() => navigate(`/instructor/${course.userId}`)} // Navigate to InstructorProfile with userId
              style={{ cursor: 'pointer' }}
            >
              <img
                src={getProfilePictureUrl(
                  course.instructorProfilePicture,
                  api.img,
                  defaultProfilePic,
                  course.instructor
                )}
                alt={course.instructor}
                className="instructor-profile-icon"
              />
              <p className="cd-course-instructor-name">{course.instructor}</p>
              <p className="cd-course-instructor-bio">
                {instructor.bio || 'No bio available.'}
              </p>
            </div>

            <p className="cd-instructor-review-rating">
              {' '}
              <FaStar className="cop-star-icon" />
              <span>
                {instructorDetails?.averageRating || 0} (
                {instructorDetails?.totalRatings || 0} )
              </span>
            </p>
            {/* <p className="cd-instructor-biodata">
              "I took this course by recommendation from a YouTube video, and I didn't regret it.
              By far this is the most digestible SQL course I took. The instructor talks in a
              clear and understandable way with perfect pace and small bites for good understanding.
              I feel like I paid too little for this course and things I've learned. I recommend it with pleasure."
            </p> */}
          </div>

          {/* More Courses by Instructor */}
          {instructorCourses.length > 0 && (
            <div className="cd-more-courses">
              <h3>
                More Courses by <strong>{course.instructor}</strong>
              </h3>
              <div className="cd-more-courses-list">
                {instructorCourses.slice(0, 3).map((instructorCourse) => (
                  <div
                    key={instructorCourse._id}
                    className="cd-more-course-card"
                    onClick={() =>
                      window.open(`/courses/${instructorCourse._id}`, '_blank')
                    }
                  >
                    <img
                      src={`${api.img + instructorCourse.image}`}
                      alt={instructorCourse.title}
                      className="cd-more-course-image"
                    />
                    <h4 className="cd-more-course-title">
                      {instructorCourse.title}
                    </h4>
                    <p className="cd-more-course-rating">
                      ⭐ {instructorCourse.averageRating || '0.0'} (
                      {instructorCourse.totalRatings || 0} ratings)
                    </p>
                  </div>
                ))}
              </div>

              {instructorCourses.length > 3 && (
                <div style={{ marginTop: '15px', textAlign: 'center' }}>
                  <button
                    className="cd-more-btn"
                    onClick={() =>
                      (window.location.href = `/instructor/${course.userId}`)
                    }
                  >
                    View All Courses by {course.instructor}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="cd-course-right">
          <div className="cd-video-thumbnail-container">
            <img
              className="cd-course-thumbnail"
              src={`${api.img + course.image}`}
              alt={course.title}
            />
            <button
              className="cd-play-button"
              onClick={() => setIsVideoOpen(true)}
            >
              <FaPlay />
            </button>

            {/* Wishlist Icon */}
            {!isPurchased && (
              <button
                className="cd-wishlist-icon"
                onClick={() => handleWishlistToggle(course._id)}
              >
                <FaHeart
                  className={
                    isInWishlist ? 'wishlist-icon active' : 'wishlist-icon'
                  }
                  style={{ color: isInWishlist ? '#e63946' : '#888' }}
                />
              </button>
            )}
          </div>
          <div>
            {/* Offer Price Section */}
            <p className="cd-course-price">
              {isFree ? (
                <span className="cd-free-price">Free </span>
              ) : (
                `₹ ${offerPrice}`
              )}

              {isFree ? (
                <span
                  className="cd-original-price"
                  style={{ marginLeft: '8px' }}
                >
                  ₹{actualPrice}
                </span>
              ) : (
                <span
                  className="cd-original-price"
                  style={{ marginLeft: '8px' }}
                >
                  ₹{actualPrice}
                </span>
              )}

              {!isFree && offerPrice !== actualPrice && (
                <span className="cd-discount" style={{ marginLeft: '8px' }}>
                  {Math.round(
                    ((actualPrice - offerPrice) / actualPrice) * 100,
                  )}
                  % Off
                </span>
              )}
            </p>

            {/* Countdown Timer */}
            {/* {timeLeft > 0 ? (
              <p className="cd-course-discount-time">
                ⏳ Offer ends in: <strong>{formatTime(timeLeft)}</strong>
              </p>
            ) : (
              <p className="cd-course-discount-time">Offer Expired!</p>
            )} */}
          </div>

          <div className="cd-button-container">
            {isPurchased ? (
              <>
                <button
                  className="cd-continue-learning"
                  onClick={() => navigate(`/course/${id}`)}
                >
                  <FaPlay style={{ marginRight: '6px' }} /> Continue Learning
                </button>

                <button
                  className="cd-share-btn"
                  onClick={() => setShowShareOptions((prev) => !prev)}
                >
                  <FaShareAlt style={{ marginRight: '6px' }} /> Share this
                  course
                </button>

                {showShareOptions && (
                  <div className="cd-share-options">
                    <button
                      className="cd-share-option"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `${window.location.origin}/courses/${course._id}`,
                        );
                        setShowShareOptions(false);
                        toast.success('Link copied to clipboard!');
                      }}
                    >
                      Copy Link
                    </button>
                    <button
                      className="cd-share-option"
                      onClick={() => {
                        window.open(
                          `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Check%20out%20this%20course!&body=Check%20out%20this%20course:%20${encodeURIComponent(
                            window.location.origin + '/courses/' + course._id,
                          )}`,
                          '_blank',
                        );
                        setShowShareOptions(false);
                      }}
                    >
                      Share via Email
                    </button>
                    <button
                      className="cd-share-option"
                      onClick={() => {
                        window.open(
                          `https://wa.me/?text=Check out this course: ${window.location.origin}/courses/${course._id}`,
                        );
                        setShowShareOptions(false);
                      }}
                    >
                      Share via WhatsApp
                    </button>
                  </div>
                )}

                <button
                  className="cd-gift-btn"
                  onClick={() => setIsGiftModalOpen(true)}
                >
                  🎁 Gift this Course
                </button>
              </>
            ) : (
              <>
                {courseInCart ? (
                  <button
                    className="cd-go-to-cart"
                    onClick={() => navigate('/cart')}
                  >
                    <FaShoppingCart className="cart-icon" /> Go to Cart
                  </button>
                ) : (
                  <button className="cd-add-to-cart" onClick={handleAddToCart}>
                    <FaShoppingCart /> Add to Cart
                  </button>
                )}

                <button
                  className="cd-buy-now"
                  onClick={() => handleBuyNow(course._id, course.price)}
                >
                  <FaCreditCard /> Buy Now
                </button>

                <button
                  className="cd-share-btn"
                  onClick={() => setShowShareOptions((prev) => !prev)}
                >
                  <FaShareAlt style={{ marginRight: '6px' }} /> Share this
                  course
                </button>

                {showShareOptions && (
                  <div className="cd-share-options">
                    <button
                      className="cd-share-option"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `${window.location.origin}/courses/${course._id}`,
                        );
                        setShowShareOptions(false);
                        toast.success('Link copied to clipboard!');
                      }}
                    >
                      Copy Link
                    </button>
                    <button
                      className="cd-share-option"
                      onClick={() => {
                        window.open(
                          `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Check%20out%20this%20course!&body=Check%20out%20this%20course:%20${encodeURIComponent(
                            window.location.origin + '/courses/' + course._id,
                          )}`,
                          '_blank',
                        );
                        setShowShareOptions(false);
                      }}
                    >
                      Share via Email
                    </button>
                    <button
                      className="cd-share-option"
                      onClick={() => {
                        window.open(
                          `https://wa.me/?text=Check out this course: ${window.location.origin}/courses/${course._id}`,
                        );
                        setShowShareOptions(false);
                      }}
                    >
                      Share via WhatsApp
                    </button>
                  </div>
                )}

                <button
                  className="cd-gift-btn"
                  onClick={() => setIsGiftModalOpen(true)}
                >
                  🎁 Gift this Course
                </button>
              </>
            )}
          </div>

          <p className="cd-course-last-updated">
            🗓 Latest update:{' '}
            {course.lastUpdated
              ? format(new Date(course.lastUpdated), 'MMMM yyyy')
              : 'N/A'}
          </p>
          {/* <p className="cd-course-guarantee">✅ 30-Day Money-Back Guarantee</p> */}
          <p className="cd-course-lifetime">🔒 Lifetime Access</p>
        </div>
      </div>
      {/* Video Modal */}
      {isVideoOpen && course.video && (
        <div className="cd-video-modal">
          <div className="cd-video-container">
            <button
              className="cd-close-button"
              onClick={() => {
                // console.log('Close button clicked!');
                setIsVideoOpen(false);
              }}
            >
              <FaTimes />
            </button>

            <div className="cd-course-video-frame">
              <video className="cd-course-video" controls>
                <source src={`${api.img + course.video}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}
      {/* Video Modal */}
      <Modal
        open={isVideoModalOpen}
        onCancel={() => setIsVideoModalOpen(false)}
        footer={null}
        width="80%"
        style={{ top: 20 }}
        styles={{ body: { padding: 0 } }}
      >
        {selectedLesson && (
          <div className="cd-lesson-video-modal">
            <div className="cd-lesson-video-header">
              <h3>{selectedLesson.name}</h3>
              {/* <button
                className="cd-lesson-video-close"
                onClick={() => setIsVideoModalOpen(false)}
              >
                <FaTimes />
              </button> */}
            </div>
            <div className="cd-lesson-video-container">
              <video
                controls
                className="cd-lesson-video-player"
                src={
                  selectedLesson.video
                    ? `${api.img}${selectedLesson.video}`
                    : ''
                }
              >
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        )}
      </Modal>
      {/* Gift Course Modal */}{' '}
      <Modal
        title="Gift this Course"
        open={isGiftModalOpen}
        onCancel={() => setIsGiftModalOpen(false)}
        footer={null}
      >
        <div style={{ marginBottom: 12 }}>
          <Input
            placeholder="Recipient's Email"
            value={giftEmail}
            onChange={(e) => setGiftEmail(e.target.value)}
            onKeyPress={handleGiftKeyPress}
            disabled={isGiftChecking}
            style={{ marginBottom: 8 }}
          />
          {giftEmailError && (
            <div style={{ color: 'red', marginTop: 4 }}>{giftEmailError}</div>
          )}
        </div>
        <div style={{ marginBottom: 20 }}>
          <Input.TextArea
            placeholder="Add a personal message (optional)"
            value={giftMessage}
            onChange={(e) => setGiftMessage(e.target.value)}
            onKeyPress={handleGiftKeyPress}
            disabled={isGiftChecking}
            rows={4}
            maxLength={200}
            showCount
            style={{ resize: 'none' }}
          />
        </div>
        <Button
          type="primary"
          loading={isGiftChecking}
          onClick={handleGiftCourse}
          block
        >
          Continue to Checkout
        </Button>
      </Modal>
      {/* Link to Gifted Courses Page */}
      {/* <div style={{ marginTop: 24, textAlign: 'center' }}>
        <Link to="/gifted" style={{ color: '#4a80f0', fontWeight: 600 }}>
          View Courses You've Gifted
        </Link>
      </div> */}

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default CourseDetails;